import { useReveal } from "@/hooks/useReveal";

const CARDS = [
  {
    title: "Ecocert — USDA Organic and EU Organic",
    body: "The plant is audited annually. Certificates are available on request and the current scope covers both destination regimes.",
  },
  {
    title: "Certificate of analysis per batch",
    body: "Issued with every production run, not on request. A sample CoA format is available on request so your quality team can check the format before committing.",
  },
  {
    title: "HACCP and INVIMA",
    body: "Food safety system and registration with the Colombian food authority. Process flow diagrams and traceability records available for supplier homologation.",
  },
  {
    title: "Export documentation pack",
    body: "Organic transaction certificate, phytosanitary certificate, pallet certificate and commercial documentation, issued per shipment.",
  },
];

export default function Certification() {
  const headRef = useReveal<HTMLDivElement>();
  const cardsRef = useReveal<HTMLDivElement>();

  return (
    <section id="certification" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headRef} className="reveal max-w-[800px]">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Certification and the documents your auditor will ask for
          </h2>
          <p className="mt-4 text-ink/70 text-lg leading-relaxed">
            If you export finished product carrying an organic claim, your
            certifier will audit the chain behind every certified ingredient.
            That is the part this section exists for.
          </p>
        </div>

        <div
          ref={cardsRef}
          className="reveal mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="bg-white rounded-lg border border-cream-dark/60 p-6"
            >
              <h3 className="text-ink font-serif text-lg font-semibold leading-snug">
                {card.title}
              </h3>
              <p className="mt-3 text-ink/70 text-[15px] leading-relaxed">
                {card.body}
              </p>
            </div>
          ))}
        </div>

        <div className="reveal mt-12">
          <p className="text-ink/70 text-base">
            Certificates and technical data sheets are available on request. No form required for verification — write to us and we will send them directly.
          </p>
        </div>
      </div>
    </section>
  );
}